var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMinusRing = function SvgIcMinusRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.277 2 2 8.277 2 16s6.277 14 14 14 14-6.277 14-14S23.723 2 16 2Zm0 25.2C9.828 27.2 4.8 22.172 4.8 16S9.828 4.8 16 4.8 27.2 9.828 27.2 16 22.172 27.2 16 27.2Z",
    fill: "#83868A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.781,
    y: 14.444,
    width: 12.444,
    height: 3.111,
    rx: 1.556,
    fill: "#83868A"
  })));
};
export default SvgIcMinusRing;